import React, { PureComponent, ReactNode } from "react";
import { AppContextType } from "../../AppContext";
import { DumbAutoSetting } from "../../models/KeySelectionOptions.model";
import OptionMenuOneLineToggle from "../theme_reuse/OptionMenuOneLineToggle";

interface Props {}
interface State {}

const shortNames = [DumbAutoSetting.Manual, DumbAutoSetting.Auto];

function printShortName(x: DumbAutoSetting): string {
  switch (x) {
    case DumbAutoSetting.Manual:
      return "Do not automate";
    case DumbAutoSetting.Auto:
      return "Auto-silence mismatching 3rd";
  }
}

export default class AutoIgnore3Toggle extends PureComponent<Props, State> {
  declare context: React.ContextType<typeof AppContextType>;
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  changeSetting = (wrong3rdIgnore: DumbAutoSetting) => {
    const oldOptions = this.context.keySelectionOptions;
    this.context.dispatch({
      type: "EditKeySelectionOptions",
      payload: { ...oldOptions, autoPin: { ...oldOptions.autoPin, wrong3rdIgnore } },
    });
  };

  render(): ReactNode {
    const selected = this.context.keySelectionOptions.autoPin.wrong3rdIgnore;
    return (
      <OptionMenuOneLineToggle
        selected={selected}
        printShortName={printShortName}
        onChange={this.changeSetting}
        optionShortNames={shortNames}
      />
    );
  }
}

AutoIgnore3Toggle.contextType = AppContextType;
